<template>
  <div>
    <div class="cont-xw clearfix">
      <div class="jg-head">产品图片</div>
      <div style="overflow: hidden" class="text-center">
        <div class="text-center">
          <img
            class="form-group col-md-6 col-xs-6 col-sm-6"
            style="float:none"
            src="../../common/images/BU02.jpg"
          />
          <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
        </div>
      </div>
      <div class="jg-head">产品概述</div>
      <p>IVF-BU02是在第一代UHF蓝牙读卡器BU01上面的第二种延伸，可通过蓝牙接口与windows、ios、android等智能系统平台连接，当作模拟键盘使用。集成二维条码识读引擎以及UHF RFID读写模块，采用先进的CMOS影像识别技术，智能图像识别系统，可以轻松读取纸张、商品等介质上的条码，同时识别介质上的RFID信息。设备无需二次开发，并兼容各种应用软件，便于各种场合的应用。</p>
      <div class="jg-head">参数规格</div>
      <p>支持超高频（UHF）标签协议ISO18000-6C</p>
      <p>支持系统：Windows、IOS、Android</p>
      <p>通信接口：BLE4.0、HID</p>
      <p>RFID读取距离：2-20cm（视标签大小而定））</p>
      <p>1D/2D读取距离： 20mm~310mm</p>
      <p>
        识读码制：1D：UPC-A , UPC-E, UPC-E1, EAN-8, EAN-13,EAN-14, EAN-128, UCC128, ISBN/ISSN,CODE11, CODE32, CODE39, CODE39 Full ASCII, CODE93,CODE128,交叉25码，工业25码，矩阵25码，中国邮政码，UK/Plessey,GS1，etc.
        2D: QR Code, Data Matrix，PDF417，etc.
      </p>
      <p>工作时长：开机待机260小时，连续工作26小时（无补光照明连续频繁的手动按键读取）</p>
      <p>工作次数：连续工作读取25000次（无补光照明连续频繁的手动按键读取）</p>
      <p>材料：ABS+PC工程塑料</p>
      <p>电池容量：2600mA</p>
      <p>充电方式：USB 5V/1A，充电5小时</p>
      <p>蜂鸣器：内置蜂鸣器</p>

      <p>按键：按键触发读取</p>

      <p>工作环境温度：-20℃~50℃</p>
      <div class="jg-head">指示灯状态</div>
      <p>中间灯:</p>
      <p>①、正常工作：绿灯长亮</p>
      <p>②、读取成功：绿灯闪烁</p>
      <p>③、设备异常：蓝牙连接上后绿灯不亮</p>
      <p>④、电 量 低：绿灯一直闪烁（低电报警，请尽快充电）</p>
      <p>⑤、充 电 中：红灯长亮</p>
      <p>⑥、充电完成：红灯灭掉</p>
      <p>拨扭开关：1-预留、2-预留、3&4 -功能键、5-电源开关；</p>
      <p>拨扭3&4的功能说明表：</p>
      <table class="table table-bordered">
        <tr>
          <th>项目</th>
          <th>拨扭3</th>
          <th>拨扭4</th>
          <th>设备模式</th>
        </tr>
        <tr>
          <td>状态</td>
          <td>OFF</td>
          <td>OFF</td>
          <td>1D/2D+RFID</td>
        </tr>
        <tr>
          <td>状态</td>
          <td>ON</td>
          <td>ON</td>
          <td>RFID</td>
        </tr>
        <tr>
          <td>状态</td>
          <td>OFF</td>
          <td>ON</td>
          <td>RFID</td>
        </tr>
        <tr>
          <td>状态</td>
          <td>ON</td>
          <td>ON</td>
          <td>1D/2D</td>
        </tr>
      </table>
      <div class="jg-head">应用特点</div>
      <div>无需APP、无需驱动，不分系统平台，即连即用；</div>
      <div class="jg-head">使用方法</div>
      <p>蓝牙HID键盘，使用需要注意输入法要在英文字母输入状态(如下图一)；</p>
      <p>1.设备开机上电；</p>
      <p>2.在手机者平或板设置里面，配置连接产品对应编号的蓝牙连接(如下图二)；</p>
      <p>3.打开文本或者word等输入框(如下图三)；</p>
      <p>4.靠近标签读取即可在终端显示EPC。</p>
      <div class="clearfix">
        <div class="col-md-6 col-xs-12">
           <img class="content" style="width: 100%" src="../../common/images/BU01KB-1.jpg" />
        </div>
        <div class="col-md-6  col-xs-12">
           <img class="content" style="width: 100%" src="../../common/images/BU01KB-2.jpg" />
        </div>
         <div class="col-md-6  col-xs-12">
           <img class="content" style="width: 100%" src="../../common/images/BU02-3.jpg" />
        </div>
      </div>

      <div class="jg-head">输出示例说明：</div>
      <p>以下分别为：1D/2D+RFID模式、1D/2D+RFID模式、1D/2D+RFID模式</p>
      <div class="box-row">
        <img class="content" src="../../common/images/BU02-4.jpg" />
      </div>
      <div class="jg-head">补光照明灯说明</div>
      <p>照明灯可为拍摄识读提供辅助照明，光束照射在识读目标上，提高识读性能和弱环境光照时的适应能力。用户可根据应用环境将其设置为以下状态中的一种：</p>
      <div class="box-row">
        <img class="content" src="../../common/images/BU02-5.jpg" />
      </div>

      <div id="fast" class="jg-head">下载</div>
      <ul>
        <li class="form-group">
          <FileDownload href="/static/IVF-BU/IVF-BU02规格书.doc">产品规格书</FileDownload>
        </li>
        <li class="form-group">
          <QRDownload></QRDownload>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FileDownload from "@/base/filedownload";
import QRDownload from "@/base/qrdownload";
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
  methods: {
    riseup() {
      riseup()
    }
  },
  components: { FileDownload, QRDownload }
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/SMQ/02.vue